/** Decoración de pestañas y subsecciones de Historia */

export const ARCHIVE_TAB_DECOR = {
  historia: { kanji: '史', num: '01' },
  relaciones: { kanji: '交', num: '02' },
  economia: { kanji: '財', num: '03' },
  'eventos-historicos': { kanji: '録', num: '04' },
  actualidad: { kanji: '今', num: '05' },
  clima: { kanji: '天', num: '06' },
  ciudad: { kanji: '城', num: '07' },
  fronteras: { kanji: '境', num: '08' },
  cultura: { kanji: '文', num: '09' },
  defensas: { kanji: '盾', num: '10' },
}

export const HISTORIA_SECTION_DECOR = {
  'historia-origen': { num: '·' },
  'historia-capitulo-1': { num: 'I' },
  'historia-capitulo-2': { num: 'II' },
  'historia-capitulo-3': { num: 'III' },
  'historia-capitulo-4': { num: 'IV' },
  'historia-capitulo-5': { num: 'V' },
  'historia-epilogo': { num: '∎' },
}

export function getTabDecor(tabId) {
  return ARCHIVE_TAB_DECOR[tabId] || { kanji: '卷', num: '' }
}

export function getHistoriaSectionDecor(sectionId) {
  return HISTORIA_SECTION_DECOR[sectionId] || { num: '' }
}
